import PropTypes from "prop-types";
import React from "react";

/* -------------------------------------------------------------------------
 * StatCard — metric card matching settlement dashboard style with icon,
 * title, value, delta percentage, and secondary metrics.
 * ---------------------------------------------------------------------- */

const StatCard = ({ 
  label, 
  value, 
  delta, 
  deltaTone, 
  deltaSubtitle, 
  sparklineData, 
  sparklineColor, 
  actionLabel, 
  onAction,
  titleColor,
  icon,
  iconBg,
  deltaPct,
  secondaryLabel,
  secondaryValue,
  periodLabel
}) => (
  <div className="rp-card stl-stat-card">
    <div className="stl-stat-card__top">
      <span className="stl-stat-card__title" style={{ color: titleColor }}>
        {label}
      </span>
      {icon && (
        <span className="stl-stat-card__icon" style={{ background: iconBg, color: titleColor }}>{icon}</span>
      )}
    </div>
    <div className="stl-stat-card__value">{value}</div>
    <div className="stl-stat-card__delta-row">
      <span className="stl-stat-card__delta-label">{periodLabel || deltaSubtitle}</span>
      {deltaPct !== null && deltaPct !== undefined ? (
        <span className={`stl-stat-card__delta ${deltaPct >= 0 ? "stl-stat-card__delta--up" : "stl-stat-card__delta--down"}`}>
          {deltaPct >= 0 ? "↑" : "↓"} {Math.abs(deltaPct)}%
        </span>
      ) : delta ? (
        <span className={`stl-stat-card__delta ${deltaTone === "positive" ? "stl-stat-card__delta--up" : "stl-stat-card__delta--down"}`}>
          {delta}
        </span>
      ) : null}
    </div>
    {secondaryLabel && secondaryValue && (
      <div className="stl-stat-card__secondary">
        <span>{secondaryLabel}</span>
        <strong>{secondaryValue}</strong>
      </div>
    )}
  </div>
);

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  delta: PropTypes.string,
  deltaTone: PropTypes.oneOf(["positive", "negative"]),
  deltaSubtitle: PropTypes.string,
  sparklineData: PropTypes.arrayOf(PropTypes.number),
  sparklineColor: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  titleColor: PropTypes.string,
  icon: PropTypes.node,
  iconBg: PropTypes.string,
  deltaPct: PropTypes.number,
  secondaryLabel: PropTypes.string,
  secondaryValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  periodLabel: PropTypes.string,
};

StatCard.defaultProps = {
  delta: null,
  deltaTone: "positive",
  deltaSubtitle: null,
  sparklineData: null,
  sparklineColor: "#1ba97f",
  actionLabel: null,
  onAction: () => {},
  titleColor: "var(--text-black)",
  icon: null,
  iconBg: "var(--bg-light-grey)",
  deltaPct: null,
  secondaryLabel: null,
  secondaryValue: null,
  periodLabel: "This Month",
};

export default StatCard;
